module.exports = __webpack_public_path__ + "img/camp_shirt_other12.85807a06.svg";